/**
 * Web app URL (Expo web app - login and public profiles).
 *
 * - For production on www.fit-match.co.uk, we serve the Expo web build under /app via Firebase Hosting.
 *   Set REACT_APP_WEB_APP_URL="/app" in your production environment so the Login button opens the web app.
 *
 * - For local dev, you can either:
 *   - Use the Firebase Hosting emulator (recommended for full E2E): REACT_APP_WEB_APP_URL="/app"
 *     and follow the build+copy steps so /app is served by Firebase.
 *   - Or run Expo web directly and point this at that URL (e.g. http://localhost:8081).
 */
export const WEB_APP_URL =
  process.env.REACT_APP_WEB_APP_URL || "/app";
